<template>
  <Layout :tituloPagina="'Inicio Hotspot'">
    <div class="row" v-show="!$store.state.todo.susargus">
      <div class="col-lg-12">
        <div class="card bg-warning text-white">
          <div class="card-body text-center">
            <p class="card-text">
              Su suscripción ha caducado, debe de pagar su mensualidad para seguir disfrutando de ArgusBlack, 
              visite la sección <a href="/sistema/cuenta/" style="color: red;">CUENTA</a> para renovarla en este momento.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpSesionesActivasHotspot','componente') && widgets.WFichas">
        <WFichas></WFichas>
      </div>
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpFichasCreadasHotspot','componente') && widgets.WHotspots">
        <WHotspots></WHotspots>
      </div>
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpFichasVendidasHotspot','componente') && widgets.WLayouts">
        <WLayouts></WLayouts>
      </div>
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpFichasEliminadasHotspot','componente') && widgets.WVendedores">
        <WVendedores></WVendedores>
      </div>
    </div>
    <div class="row">
      <div class="col-xxl-6" v-if="tienePermiso('cmpVentasYComisiones','componente') && widgets. WVentasYComisiones">
        <WVentasYComisiones></WVentasYComisiones>
      </div>
      <div class="col-xxl-6" v-if="tienePermiso('cmpIngresosHotspot','componente') && widgets.WIngresos">
        <WIngresos></WIngresos>
      </div>
    </div>
    <widgets-visibles 
      ref="widgetsHotspot"
      @actualizar-widgets="cargarAjustesWidgets()"
    ></widgets-visibles>
    <br>
  </Layout>
</template>

<script>
import UsuarioSrv from '@/services/UsuarioSrv.js'
import Layout from "@/views/layouts/main.vue"

import WHotspots from './WHotspots.vue'
import WFichas from './WFichas.vue'
import WLayouts from './WLayouts.vue'
import WVendedores from './WVendedores.vue'
import WIngresos from './WIngresos.vue'
import WVentasYComisiones from "./WVentasYComisiones.vue"
import WidgetsVisibles from './WidgetsVisibles.vue'

import { todoGetters } from "@/state/helpers";

export default {
  name: 'Inicio',
  components: {
    Layout,
    WHotspots,
    WFichas,
    WLayouts,
    WVendedores,
    WIngresos,
    WVentasYComisiones,
    WidgetsVisibles
  },
  data() {
    return {
      widgets: {
        WHotspots: false,
        WFichas: false,
        WLayouts: false,
        WVendedores: false,
        WIngresos: false,
        WVentasYComisiones: false
      }
    }
  },
  created: function() {
    var self = this

    self.cargarAjustesWidgets()
  },
  computed: { ...todoGetters },
  methods: {    
    cargarAjustesWidgets: function() {
      var self = this
      var widgets = [
        'WHotspots','WFichas','WLayouts','WVendedores','WIngresos','WVentasYComisiones'
      ]

      UsuarioSrv.ajustesJSON(widgets).then(response => {
        let ajustes = response.data

        // Convertimos y asignamos cada valor al objeto widgets
        for (const key in ajustes) {
          if (self.widgets.hasOwnProperty(key)) {
            self.widgets[key] = ajustes[key] === '1'; // Convertimos a booleano
          }
        }
      }).catch(error => {
        let mensaje 
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar los ajustes del widgets'
        }
        console.log(error)
        iu.msg.error(mensaje)
      })
    }
  }
}
</script>

<style scoped>

</style>